"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[777],{

/***/ 28731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* reexport */ Banner; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/components/container/src/index.ts + 1 modules
var src = __webpack_require__(13920);
// EXTERNAL MODULE: ../../packages/components/theme/src/index.ts + 2 modules
var theme_src = __webpack_require__(88451);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(4309);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ../../packages/components/commons/src/index.ts + 2 modules
var commons_src = __webpack_require__(10317);
// EXTERNAL MODULE: ../../node_modules/react-native-media-query/index.web.js + 17 modules
var index_web = __webpack_require__(97888);
;// CONCATENATED MODULE: ../../packages/components/banner/src/styles.ts

var getBannerTextStyles = function getBannerTextStyles(_ref) {
  var colors = _ref.colors,
      spacing = _ref.spacing,
      typography = _ref.typography,
      alignment = _ref.alignment;
  return index_web/* default.create */.Z.create({
    baseStyles: {
      backgroundColor: colors.background.mid
    },
    textContainer: {
      justifyContent: alignment === 'center' ? 'center' : alignment === 'left' ? 'flex-start' : 'flex-end',
      paddingVertical: spacing['4xlarge'],
      '@media (min-width: 768px)': {
        paddingVertical: spacing['5xlarge']
      },
      '@media (min-width: 992px)': {
        paddingVertical: spacing['6xlarge']
      }
    },
    textStyles: {
      color: colors.foreground.mid,
      fontSize: typography.fontSize['3xlarge'],
      '@media (min-width: 768px)': {
        fontSize: typography.fontSize['5xlarge']
      },
      '@media (min-width: 992px)': {
        fontSize: typography.fontSize['6xlarge']
      },
      fontFamily: typography.fontFamily.bold
    }
  });
};
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../packages/components/banner/src/BannerText.tsx







var BannerText = function BannerText(_ref) {
  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      text = _ref.text,
      alignment = _ref.alignment;

  var _useTheme = (0,theme_src/* useTheme */.Fg)(),
      spacing = _useTheme.spacing,
      colorPairs = _useTheme.colorPairs,
      typography = _useTheme.typography;

  var colors = colorPairs[appearance];

  var _getBannerTextStyles = getBannerTextStyles({
    spacing: spacing,
    colors: colors,
    typography: typography,
    alignment: alignment
  }),
      ids = _getBannerTextStyles.ids,
      styles = _getBannerTextStyles.styles;

  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: styles.baseStyles,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(src/* Container */.W, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        dataSet: {
          media: ids.textContainer
        },
        style: styles.textContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(commons_src/* Text */.xv, {
          dataSet: {
            media: ids.textStyles
          },
          style: styles.textStyles,
          children: text
        })
      })
    })
  });
};
// EXTERNAL MODULE: ../../packages/components/image/src/index.ts + 2 modules
var image_src = __webpack_require__(39998);
;// CONCATENATED MODULE: ../../packages/components/banner/src/BannerImage.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var BannerImage = function BannerImage(_ref) {
  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      text = _ref.text,
      alignment = _ref.alignment,
      image = _ref.image;

  var _useTheme = (0,theme_src/* useTheme */.Fg)(),
      spacing = _useTheme.spacing,
      colorPairs = _useTheme.colorPairs,
      typography = _useTheme.typography;

  var colors = colorPairs[appearance];

  var _getBannerTextStyles = getBannerTextStyles({
    spacing: spacing,
    colors: colors,
    typography: typography,
    alignment: alignment
  }),
      ids = _getBannerTextStyles.ids,
      styles = _getBannerTextStyles.styles;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    children: [image && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_src/* Image */.E, {
        style: {
          resizeMode: 'cover',
          aspectRatio: image.aspectRatio,
          flex: 1
        },
        url: image.url,
        alt: image.alt
      })
    }), text && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: {
        position: 'relative'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: _objectSpread(_objectSpread({}, styles.baseStyles), {}, {
          position: 'absolute',
          top: '50%',
          left: '50%'
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(src/* Container */.W, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            dataSet: {
              media: ids.textContainer
            },
            style: styles.textContainer,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(commons_src/* Text */.xv, {
              dataSet: {
                media: ids.textStyles
              },
              style: styles.textStyles,
              children: text
            })
          })
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/components/banner/src/Banner.tsx


var _excluded = ["type"];

function Banner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Banner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Banner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Banner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Banner = function Banner(_ref) {
  var type = _ref.type,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (type === 'text') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(BannerText, Banner_objectSpread({}, props));
  } else if (type === 'image') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(BannerImage, Banner_objectSpread({}, props));
  } else {
    // TODO add banner variants
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }
};
;// CONCATENATED MODULE: ../../packages/components/banner/src/index.ts


/***/ }),

/***/ 7255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* reexport */ MembershipList; }
});

// UNUSED EXPORTS: MembershipCard

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/cjs/exports/Pressable/index.js
var Pressable = __webpack_require__(55876);
var Pressable_default = /*#__PURE__*/__webpack_require__.n(Pressable);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(4309);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ../../node_modules/react-native-web-linear-gradient/dist/index.js
var dist = __webpack_require__(23376);
// EXTERNAL MODULE: ../../packages/components/image/src/index.ts + 2 modules
var src = __webpack_require__(39998);
// EXTERNAL MODULE: ../../packages/components/theme/src/index.ts + 2 modules
var theme_src = __webpack_require__(88451);
// EXTERNAL MODULE: ../../packages/components/button/src/index.ts + 2 modules
var button_src = __webpack_require__(23227);
// EXTERNAL MODULE: ../../packages/components/commons/src/index.ts + 2 modules
var commons_src = __webpack_require__(10317);
// EXTERNAL MODULE: ../../node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(63488);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ../../node_modules/react-native-media-query/index.web.js + 17 modules
var index_web = __webpack_require__(97888);
;// CONCATENATED MODULE: ../../packages/components/membership-card/src/styles.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getMembershipCardStyles = function getMembershipCardStyles(_ref) {
  var spacing = _ref.spacing,
      radius = _ref.radius,
      colors = _ref.colors,
      headings = _ref.headings,
      typography = _ref.typography,
      isHover = _ref.isHover,
      numColumns = _ref.numColumns,
      isNative = _ref.isNative;
  return StyleSheet_default().create({
    container: {
      flex: 1 / numColumns,
      marginRight: isNative && numColumns > 1 ? spacing === null || spacing === void 0 ? void 0 : spacing['3xlarge'] : 0,
      marginBottom: spacing === null || spacing === void 0 ? void 0 : spacing['3xlarge'],
      alignContent: 'center',
      // transition: 'transform 0.1s ease-in-out',
      transform: [{
        scale: isHover ? 1.01 : 1
      }]
    },
    imageContainer: {},
    imageStyles: {
      aspectRatio: 3 / 1.75,
      resizeMode: 'cover',
      borderTopLeftRadius: radius.large,
      borderTopRightRadius: radius.large
    },
    detailsContainer: {
      flexGrow: 1,
      paddingVertical: spacing.large,
      paddingHorizontal: spacing === null || spacing === void 0 ? void 0 : spacing['2xlarge'],
      borderBottomLeftRadius: radius.large,
      borderBottomRightRadius: radius.large,
      backgroundColor: colors.background.mid
    },
    headerText: _objectSpread(_objectSpread({}, headings[2]), {}, {
      color: colors.foreground.mid,
      marginTop: spacing.large
    }),
    subTitle: _objectSpread(_objectSpread({}, headings[3]), {}, {
      fontFamily: typography.fontFamily.semiBold,
      marginBottom: spacing.large,
      color: colors.foreground.mid
    }),
    buttonRow: {
      // flex: 0,
      // flexWrap: 'wrap',
      flexDirection: 'row',
      marginBottom: spacing.medium,
      marginTop: 'auto'
    },
    buttonContainer: {
      marginRight: spacing.large
    },
    summaryListContainer: {
      marginBottom: spacing.large
    },
    summaryItemContainer: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      marginBottom: spacing === null || spacing === void 0 ? void 0 : spacing['2xsmall'],
      alignItems: 'center'
    }
  });
};
var getMembershipListForDesktop = function getMembershipListForDesktop(_ref2) {
  var spacing = _ref2.spacing,
      numColumns = _ref2.numColumns;
  return index_web/* default.create */.Z.create({
    container: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridGap: spacing.large,
      '@media (min-width: 992px)': {
        gridTemplateColumns: "repeat(".concat(numColumns, ", 1fr)"),
        gridGap: spacing['5xlarge']
      },
      flexGrow: 1
    }
  });
};
// EXTERNAL MODULE: ../../packages/components/icons/src/index.ts + 36 modules
var icons_src = __webpack_require__(32598);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../packages/components/membership-card/src/MembershipCard.tsx


function MembershipCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MembershipCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MembershipCard_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MembershipCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



 // import Animated, { useSharedValue, useAnimatedStyle, Easing, withTiming, withSequence } from 'react-native-reanimated';











var MembershipCard = function MembershipCard(_ref) {
  var _ref2;

  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'light' : _ref$appearance,
      joinButton = _ref.joinButton,
      moreInfoButton = _ref.moreInfoButton,
      subTitle = _ref.subTitle,
      summaryList = _ref.summaryList,
      title = _ref.title,
      image = _ref.image,
      onCardPress = _ref.onCardPress,
      numColumns = _ref.numColumns,
      isNative = _ref.isNative,
      _ref$isGradient = _ref.isGradient,
      isGradient = _ref$isGradient === void 0 ? false : _ref$isGradient;

  var _useState = (0,react.useState)(null),
      isHover = _useState[0],
      setIsHover = _useState[1];

  var _useTheme = (0,theme_src/* useTheme */.Fg)(),
      colorPairs = _useTheme.colorPairs,
      spacing = _useTheme.spacing,
      radius = _useTheme.radius,
      headings = _useTheme.headings,
      typography = _useTheme.typography;

  var colors = colorPairs[(_ref2 = appearance) !== null && _ref2 !== void 0 ? _ref2 : 'primary'];
  var styles = getMembershipCardStyles({
    colors: colors,
    spacing: spacing,
    radius: radius,
    headings: headings,
    typography: typography,
    isHover: isHover,
    numColumns: numColumns,
    isNative: isNative !== null && isNative !== void 0 ? isNative : true
  }); // const offset = useSharedValue(10);
  // const opacity = useSharedValue(1);
  // const animatedStyles = useAnimatedStyle(() => {
  //   return {
  //     transform: [{ translateY: offset.value }],
  //     opacity: opacity.value,
  //     backgroundColor: colors.background.mid,
  //     borderBottomLeftRadius: radius.large,
  //     borderBottomRightRadius: radius.large,
  //     borderTopLeftRadius: radius.large,
  //     borderTopRightRadius: radius.large,
  //     flex: 1,
  //   };
  // });
  // useEffect(() => {
  //   opacity.value = 0;
  //   setTimeout(() => {
  //     offset.value = withSequence(
  //       withTiming(50, {
  //         duration: 100,
  //         easing: Easing.out(Easing.exp),
  //       }),
  //       withTiming(0, {
  //         duration: 1000,
  //         easing: Easing.out(Easing.exp),
  //       }),
  //     );
  //   }, Math.floor(Math.random() * 25));
  //   opacity.value = withTiming(1, { duration: 100, easing: Easing.out(Easing.exp) });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [id]);

  var detailsContent = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(commons_src/* Text */.xv, {
        style: styles.headerText,
        children: title
      })
    }), subTitle && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(commons_src/* Text */.xv, {
        style: styles.subTitle,
        children: subTitle
      })
    }), summaryList && summaryList.length ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: styles.summaryListContainer,
      children: summaryList.map(function (item, index) {
        var _typography$fontSize, _colors$foreground;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: styles.summaryItemContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_src/* Icons */.P, {
              type: item.icon,
              color: colors === null || colors === void 0 ? void 0 : colors.foreground.mid,
              width: (_typography$fontSize = typography.fontSize) === null || _typography$fontSize === void 0 ? void 0 : _typography$fontSize['3xlarge']
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(commons_src/* Text */.xv, {
            style: {
              color: colors === null || colors === void 0 ? void 0 : (_colors$foreground = colors.foreground) === null || _colors$foreground === void 0 ? void 0 : _colors$foreground.mid
            },
            children: item.description
          })]
        }, index);
      })
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: styles.buttonRow,
      children: [joinButton && joinButton.title && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.buttonContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_src/* Button */.zx, MembershipCard_objectSpread(MembershipCard_objectSpread({}, joinButton), {}, {
          borderRadius: radius.small
        }))
      }), moreInfoButton && moreInfoButton.title && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_src/* Button */.zx, MembershipCard_objectSpread(MembershipCard_objectSpread({}, moreInfoButton), {}, {
          borderRadius: radius.small
        }))
      })]
    })]
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)((Pressable_default()), {
    onHoverIn: function onHoverIn() {
      return setIsHover(true);
    },
    onHoverOut: function onHoverOut() {
      return setIsHover(false);
    },
    onPress: onCardPress,
    style: styles.container,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: {
        flex: styles.container.flex
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.imageContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(src/* Image */.E, {
          style: styles.imageStyles,
          url: image.url,
          alt: image.alt
        })
      }), isGradient ? /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
        colors: isGradient ? [colors.background.light, colors.background.mid, colors.background.dark, colors.background.mid, colors.background.light] : [colors.background.mid],
        useAngle: isGradient ? true : false,
        angle: 45,
        angleCenter: {
          x: 0.5,
          y: 0.5
        },
        style: styles.detailsContainer,
        children: detailsContent
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.detailsContainer,
        children: detailsContent
      })]
    })
  });
};
// EXTERNAL MODULE: ../../packages/components/app-config/src/index.ts + 2 modules
var app_config_src = __webpack_require__(53821);
;// CONCATENATED MODULE: ../../packages/components/membership-card/src/MembershipList.tsx


function MembershipList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MembershipList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MembershipList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MembershipList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var MembershipList = function MembershipList(_ref) {
  var membershipList = _ref.membershipList,
      numColumns = _ref.numColumns;

  var _useAppConfig = (0,app_config_src/* useAppConfig */.M)(),
      setNavigation = _useAppConfig.setNavigation;

  var _useTheme = (0,theme_src/* useTheme */.Fg)(),
      spacing = _useTheme.spacing;

  var _getMembershipListFor = getMembershipListForDesktop({
    spacing: spacing,
    numColumns: numColumns
  }),
      ids = _getMembershipListFor.ids,
      styles = _getMembershipListFor.styles;

  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: styles.container,
    dataSet: {
      media: ids.container
    },
    children: membershipList.map(function (item) {
      var _item$isGradient;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(MembershipCard, {
        id: item.id,
        appearance: item.appearance,
        title: item.title,
        subTitle: item.subTitle,
        joinButton: MembershipList_objectSpread(MembershipList_objectSpread({}, item.joinButton), {}, {
          onPress: function onPress() {
            var _item$joinButton$href, _item$joinButton;

            setNavigation && setNavigation((_item$joinButton$href = (_item$joinButton = item.joinButton) === null || _item$joinButton === void 0 ? void 0 : _item$joinButton.href) !== null && _item$joinButton$href !== void 0 ? _item$joinButton$href : '');
          }
        }),
        summaryList: item.summaryList,
        moreInfoButton: MembershipList_objectSpread(MembershipList_objectSpread({}, item.moreInfoButton), {}, {
          onPress: function onPress() {
            var _item$moreInfoButton$, _item$moreInfoButton;

            setNavigation && setNavigation((_item$moreInfoButton$ = (_item$moreInfoButton = item.moreInfoButton) === null || _item$moreInfoButton === void 0 ? void 0 : _item$moreInfoButton.href) !== null && _item$moreInfoButton$ !== void 0 ? _item$moreInfoButton$ : '');
          }
        }),
        image: item.image,
        onCardPress: function onCardPress() {
          var _item$moreInfoButton$2, _item$moreInfoButton2;

          setNavigation && setNavigation((_item$moreInfoButton$2 = (_item$moreInfoButton2 = item.moreInfoButton) === null || _item$moreInfoButton2 === void 0 ? void 0 : _item$moreInfoButton2.href) !== null && _item$moreInfoButton$2 !== void 0 ? _item$moreInfoButton$2 : '');
        },
        numColumns: numColumns,
        isNative: false,
        isGradient: (_item$isGradient = item.isGradient) !== null && _item$isGradient !== void 0 ? _item$isGradient : false
      }, item.id);
    })
  });
};
;// CONCATENATED MODULE: ../../packages/components/membership-card/src/index.ts



/***/ })

}]);